// Карточка блока главной — существующая обёртка Wrapper из sputnik-ui (рамка
// и скругление темы, без тени, как карточки макета v3) и ссылки в ней.

import styled from 'styled-components'
import { Link } from '@material-ui/core'
import { Wrapper } from 'sputnik-ui'

export const HomeCard = styled(Wrapper).attrs({
  background: 'primary',
  shadow: false,
  border: true,
})`
  flex-direction: column;
  gap: 0.625rem;
`

export const HomeCardHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.325rem 1rem;
`

// Ссылка-действие Контроля — синий цвет темы (как «Что изменилось» в макете).
export const TextLink = styled(Link)`
  && {
    color: ${(p) => p.theme.palette.blue.main};
    cursor: pointer;
  }
`

// Город — основной текст с пунктиром (как у чипов-фильтров), улица — вторичный.
export const CityLink = styled(Link)`
  && {
    color: ${(p) => p.theme.palette.text.primary};
    text-decoration: none;
    border-bottom: 1px dashed ${(p) => p.theme.palette.stroke.icon};
    &:hover {
      text-decoration: none;
      border-bottom-color: ${(p) => p.theme.palette.text.primary};
    }
  }
`

export const StreetLink = styled(Link)`
  && {
    color: ${(p) => p.theme.palette.text.secondary};
    &:hover {
      color: ${(p) => p.theme.palette.text.primary};
    }
  }
`

// Якорь sticky-поиска: ссылки из карточек прокручивают страницу к списку.
export const HOME_SEARCH_ANCHOR_ID = 'home-devices-search'
